/** @format */
import { css } from 'styled-components';

import { safeObjectFit, smallTablet } from '@toucan/client/global/application';
import { theme } from '@toucan/client/global/theme';

const BORDER_RADIUS = '0.8rem';

const baseStyles = css`
    padding: var(--layout-spacing-16);
    box-shadow: var(--effects-shadow-base);
    border-radius: ${BORDER_RADIUS};

    width: 46.4rem;

    .image,
    .skeleton-image {
        padding-top: 100%;
    }

    .teaser {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .skeleton-title .skeleton:nth-last-child(1) {
        display: none;
    }

    .skeleton-teaser .skeleton:nth-last-child(-n + 2) {
        display: none;
    }

    .skeleton-publish-date {
        width: 15%;
    }

    .skeleton-teaser {
        width: 90%;
    }

    .skeleton-read-more {
        width: 30%;
    }

    ${smallTablet(css`
        width: 26rem;

        .image,
        .skeleton-image {
            padding-top: 84%;
        }

        .teaser {
            -webkit-line-clamp: 4;
        }

        .skeleton-publish-date {
            width: 30%;
        }

        .skeleton-read-more {
            width: 60%;
        }
    `)}
`;

const imageStyles = css`
    .image,
    .skeleton-image {
        position: relative;
        overflow: hidden;
        margin-bottom: var(--layout-spacing-16);

        img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            ${safeObjectFit('cover')};
            border-radius: ${BORDER_RADIUS};
        }
    }

    .category {
        position: absolute;
        top: var(--layout-spacing-16);
        left: var(--layout-spacing-16);
        padding: 0.1rem var(--layout-spacing-16);
        ${theme.typography.caption};
    }
`;

const titleStyles = css`
    .title,
    .skeleton-title {
        margin-bottom: var(--layout-spacing-8);
    }
`;

const publishDateStyles = css`
    .publish-date,
    .skeleton-publish-date {
        display: block;
        margin-bottom: var(--layout-spacing-8);

        ${theme.typography.caption};
    }
`;

const teaserStyles = css`
    .teaser,
    .skeleton-teaser {
        margin-bottom: var(--layout-spacing-16);
    }
`;

export const styles = () => css`
    ${baseStyles};
    ${imageStyles};
    ${titleStyles};
    ${publishDateStyles};
    ${teaserStyles};
`;
